
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import ModalContainer from '@hems/component/src/modal/ModalContainer.vue';
import MobileAppLink from '@hems/portal/src/components/link/MobileAppLink.vue';
import { getMobileAppLinkConfig } from '@hems/portal/src/config/appLinkConfig';
import type { AppStoreType, MobileAppType } from '@hems/portal/src/config/constantPortal';
import { APP_STORE_TYPE, MOBILE_APP_TYPE } from '@hems/portal/src/config/constantPortal';
import { useFailModal } from '@hems/util/src/composable/modal';

const mobileAppTypeList = [MOBILE_APP_TYPE.PRO, MOBILE_APP_TYPE.HOME];

export default defineComponent({
  name: 'MobileAppLinkModal',
  components: {
    MobileAppLink,
    ModalContainer,
  },
  props: {
    storeType: {
      type: String as PropType<AppStoreType>,
      default: APP_STORE_TYPE.GOOGLE,
    },
  },
  emits: ['close'],
  setup(props) {
    const { t } = useI18n();

    const mobileAppLinkConfig = getMobileAppLinkConfig();

    const unknownErrorModal = useFailModal({
      content: t('message.unknown_error'),
    });

    const openStoreUrl = (appType: MobileAppType) => {
      if (!props.storeType) {
        unknownErrorModal.open();

        return;
      }

      const link = mobileAppLinkConfig[appType].link[props.storeType];
      if (!link) {
        unknownErrorModal.open();

        return;
      }
      window.open(link, '_blank');
    };

    return {
      openStoreUrl,
      mobileAppTypeList,
      mobileAppLinkConfig,
    };
  },
});
